import { useEffect, useCallback, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const FACEBOOK_PIXEL_ID = '993466670351780';

export function useFacebookPixel() {
  const location = useLocation();
  const prevPathRef = useRef('');

  useEffect(() => {
    const path = location.pathname;
    if (path === prevPathRef.current) return;
    prevPathRef.current = path;

    if (typeof window.fbq === 'undefined' || !window.fbq) return;

    try {
      window.fbq('track', 'PageView');
    } catch (e) {
      console.warn('[Facebook Pixel] PageView failed:', e);
    }
  }, [location.pathname]);

  const trackEvent = useCallback((event, properties) => {
    if (typeof window.fbq === 'undefined' || !window.fbq) {
      console.warn('[Facebook Pixel] not loaded');
      return;
    }
    try {
      window.fbq('track', event, properties || {});
    } catch (e) {
      console.warn(`[Facebook Pixel] track(${event}) failed:`, e);
    }
  }, []);

  return { trackEvent, pixelId: FACEBOOK_PIXEL_ID };
}

export default useFacebookPixel;
